import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-lp_button_loading_light",
  "use": "icon-lp_button_loading_light-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 13\" id=\"icon-lp_button_loading_light\"><path fill=\"#7EBE4B\" d=\"M4.1 2.237a4.667 4.667 0 1 1-2.767 4.266V6.02a.583.583 0 1 0-1.166 0v.483a5.834 5.834 0 1 0 3.459-5.331.583.583 0 0 0 .475 1.065Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol